










































































































import VueOptions from '@utils/VueOptions'
import ResourceList from '@modules/ui/List/ResourceList'
import BrandRepResourceListFilters from '@superUI/ResourceList/BrandRepResourceListFilters'
import Trigger from '@modules/ui/triggers/Trigger'
import Modal from '@/components/Modal'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'BrandRepResourceList'
  components: {
    ResourceList,
    BrandRepResourceListFilters,
    Trigger,
    Modal,
    LoadingIndicator
  }

  vue:
    props: ['brand_reps', 'actions', 'infiniteWrapper', 'options']

    data: ->
      sortList: [
        { field: 'accepted_at', value: 'Accepted At' }
        { field: 'email', value: 'Email' }
        { field: 'first_name', value: 'First Name' }
        { field: 'last_name', value: 'Last Name' }
        { field: 'admin', value: 'Admin' }
        { field: 'role', value: 'Role' }
        { field: 'created_at', value: 'Created At' }
        { field: 'updated_at', value: 'Updated At' }
        { field: 'onboarded_at', value: 'Onboarded At' }
        { field: 'trusted_at', value: 'Trusted At' }
        { field: 'recess_verified_at', value: 'Recess Verified At' }
        { field: 'last_emailed_at', value: 'Last Emailed At' }
      ]
      sortValue: ''

      filters:
        scopes:
          onboarding: null
          sponsor: null

        q: ''
        sort: [{ field: 'created_at', order: 'desc' }]

      pageNumber: 1
      selectedBrandReps: []
      selectedFilters: []

      verifyModal:
        show: false
        eventId: null

      switchUserModal:
        show: false
        rep: null

      deleteModal:
        modalOptions:
          title: 'Delete Brand Rep'
          button:
            label: 'Delete'
            type: 'danger'

    computed:
      components: ->
        {
          'brand-rep-resource-list-item': () => import('./BrandRepResourceListItem')
        }
      title: ->
        @options?.title || 'Brand Reps'

      resourceKey: ->
        @options?.resourceKey || 'brand_reps'

      verifiedBadgeSrc: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_verified_badge.png"

      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

      deleteTriggerResource: ->
        { key: @resourceKey, triggerName: 'delete', component: @$parent.$parent }
      deleteTriggerPayload: ->
        payload =
          brand_rep_ids: @selectedBrandReps.map((e) -> e.id)
        payload

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @filters, { page: @pageNumber })
        @pageNumber += 1

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange()

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @filters.scopes = cleared_filter_scope
        @hiFilterChange()

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        @actions.fetchResource(null, @resourceKey, @filters, { page: @pageNumber })
        @pageNumber += 1

      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @hiFilterChange()
        @sortValue = ''

      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @hiFilterChange()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = flippedOrder if item.field == sort.field
          item
        )
        @hiFilterChange()

      sortOrderIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'

        return 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) -> item.field == field).value

      handleVerifyClicked: (eventId) ->
        @verifyModal.eventId = eventId
        @verifyModal.show = true

      hiPromptToSwitchUser: (rep)->
        event.stopPropagation()
        @switchUserModal.rep = rep
        @switchUserModal.show = true

      hiSwitchUser: (rep)->
        @switchUserModal.show = false
        @switchUser rep.member_id

export default VueOptions.vue settings
